import { render, staticRenderFns } from "./GuideRemind.vue?vue&type=template&id=ea0b871a"
import script from "./GuideRemind.vue?vue&type=script&lang=js"
export * from "./GuideRemind.vue?vue&type=script&lang=js"
import style0 from "./GuideRemind.vue?vue&type=style&index=0&id=ea0b871a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports